_ = require 'underscore'
ApiPromise = require 'network/api-promise'
Dates = require 'lib/dates'
TrelloModel = require 'models/internal/trello-model'

module.exports = class CustomFieldItem extends TrelloModel
  typeName: 'CustomFieldItem'
  url: ->
    idCard = @get('idModel')
    idCustomField = @get('idCustomField')
    "/1/card/#{ idCard }/customField/#{ idCustomField }/item"

  @colors: ['green', 'yellow', 'orange', 'red', 'purple',
            'blue', 'sky', 'lime', 'pink', 'black', 'none']

  getCustomField: ->
    @modelCache.get('CustomField', @get('idCustomField'))

  clearValue: ->
    @setValue(null)

  setValue: (newValue) ->
    oldValue = null
    fieldType = @getType()
    if fieldType == 'list'
      oldValue = @get('idValue')
      @set('idValue', newValue)
      newValue = { idValue: newValue }
    else
      oldValue = @get('value')
      @set('value', newValue)
      newValue = { value: newValue }

    ApiPromise
      url: @url()
      type: 'PUT'
      data: newValue
    .catch (err) =>
      # roll back the value in modelCache
      if fieldType == 'list'
        @set('idValue', oldValue)
      else
        @set('value', oldValue)

  sync: (method, model, options) ->
    # we want to ensure that we always use PUT
    # so that when creating a custom field item it is treated more
    # as an update to the card
    # The expectation is this is just used for creation, for updates and deletes
    # use the setValue and clearValue methods instead
    options.type = 'PUT'
    super

  getType: ->
    @getCustomField()?.get('type')

  getColor: ->
    if @getType() == 'list'
      idValue = @get('idValue')
      @getCustomField().getOption(idValue)?.get('color') || 'none'
    else
      @get('color') || 'none'

  getParsedValue: ->
    value = @get('value')
    idValue = @get('idValue')
    type = @getType()
    switch type
      when 'checkbox' then value?.checked == 'true'
      when 'date' then new Date(value.date)
      when 'list' then @getCustomField().getOption(idValue)?.get('value').text || ''
      when 'number' then parseFloat(value.number)
      when 'text' then value?.text || ''

  getFrontBadgeText: ->
    parsedVal = @getParsedValue()
    type = @getType()
    switch type
      when 'checkbox' then @getCustomField().get('name')
      when 'date' then Dates.toDateString(parsedVal)
      when 'number' then parsedVal.toLocaleString()
      else parsedVal

  isEmpty: ->
    if @getType() == 'list'
      !@get('idValue')?
    else
      !@get('value')?

  showFrontBadge: ->
    customField = @getCustomField()
    if !customField?.visible()
      return false
    if @isEmpty()
      return false
    if customField.get('type') == 'checkbox' && @get('value')?.checked != 'true'
      return false
    if customField.isList() && !customField.getOption(@get('idValue'))
      return false
    return true



// WEBPACK FOOTER //
// ./app/scripts/models/custom-field-item.coffee